import React from 'react';
import { Card, CardProps } from 'antd';
import style from './style.module.scss';

export interface SectionProps extends Omit<CardProps, 'title'> {
    title?: React.ReactNode;
    /** Controls shown on the title row, outside the card and aligned right. */
    headerActions?: React.ReactNode;
    children: React.ReactNode;
    noCard?: boolean; // If true, the section will not be wrapped in a card
    className?: string;
}

export const Section = ({
    title,
    headerActions,
    children,
    noCard = false,
    className,
    ...cardProps
}: SectionProps) => {
    const titleNode = title && (
        <div className={`h5_bold ${style.title}`}>{title}</div>
    );

    return (
        <div className={`${style.section_wrapper} ${className || ''}`}>
            {headerActions ? (
                <div className={style.header}>
                    {titleNode}
                    <div className={style.header_actions}>{headerActions}</div>
                </div>
            ) : (
                titleNode
            )}
            {!noCard && <Card {...cardProps}>{children}</Card>}
            {noCard && children}
        </div>
    );
};
